module.exports = __webpack_public_path__ + "img/seventh-view.9c2fefff.jpg";